import { AppTextField } from '../../components/AppTextField';
import { CRUDType } from '../../types/crud.type';
import EditFormComponent from '../common/EditFormComponent';
import { AppFileUploadField } from '../../components/AppFileUploadField';
import { WorkoutType } from '../../types/workout.type';
import { WorkoutsServices } from '../../services/workouts.service';
import { AppAutocompleteField } from '../../components/AppAutocompleteField';
import { ExerciseTypesServices } from '../../services/exercisetypes.service';
import WorkoutPodsField from './WorkoutPodsField';
import { ValidationUtils } from '../../utils/validations.utils';
import { AppCheckboxField } from '../../components/AppCheckbox';
import { GroupRoutinesServices } from '../../services/grouproutines.service';
import SingleStationField from './SingleStationField';
import WorkoutGroupRoutinesField from './WorkoutGroupRoutinesField';

export function EditWorkout({ mode }: CRUDType) {
    return (
        <EditFormComponent<WorkoutType>
            title="Workout"
            mode={mode}
            backPath="/workouts"
            service={{
                getById: WorkoutsServices.getById,
                add: WorkoutsServices.add,
                update: WorkoutsServices.update,
            }}
            transformPayload={(data: WorkoutType) => {
                const payload = data;
                if (!payload.is_single_station) {
                    delete payload.workout_single_station;
                } else {
                }
                return payload
            }}
            formFields={[
                {
                    name: 'image',
                    component: AppFileUploadField,
                    props: {
                        label: 'Choose Workout Logo',
                        columns: 12

                    }
                },
                {
                    name: 'name',
                    component: AppTextField,
                    props: {
                        label: 'Name',
                        columns: 4,
                        rules: {
                            required: ValidationUtils.REQUIRED_FIELD_MESSAGE
                        }
                    }
                },
                {
                    name: 'workout_exercise_types',
                    component: AppAutocompleteField,
                    props: {
                        label: 'Workout Type',
                        valueProperty: 'exercise_type_id',
                        multiple: true,
                        columns: 4,
                        service: {
                            load: ExerciseTypesServices.getAll
                        },
                        rules: {
                            required: ValidationUtils.REQUIRED_FIELD_MESSAGE
                        }
                    }
                },
                {
                    name: 'warmup_id',
                    component: AppAutocompleteField,
                    props: {
                        label: 'Warmup',
                        multiple: false,
                        columns: 2,
                        service: {
                            load: GroupRoutinesServices.getAllWarmups
                        }
                    }
                },
                {
                    /* Virtual field to show/hide components if it is singleStation or with pod config */
                    name: 'is_single_station',
                    component: AppCheckboxField,
                    props: {
                        columns: 2,
                        label: 'Single Station',
                        getDerivedValue(formValues) {
                            return formValues.workout_single_station ? true : false;
                        }
                    }
                },
                {
                    name: 'description',
                    component: AppTextField,
                    props: {
                        label: 'Description',
                        multiline: true,
                        rows: 4,
                        columns: 12
                    }
                },
                {
                    name: 'workout_group_routines',
                    component: WorkoutGroupRoutinesField,
                    props: {
                        columns: 12
                    }
                },
                {
                    name: 'workout_pods',
                    component: WorkoutPodsField,
                    extraControlValues: [
                        'movement_id',
                        'hydration_break',
                        'hydration_type',
                        'is_single_pod'
                    ]
                },
                {
                    name: 'workout_single_station',
                    component: SingleStationField,
                }

            ]}
        />
    );

}